import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import Form from '../../../../components/Form';
import Address from './address';
import Contact from './contact';
import withCollegeService from '../withCollegeService';
import messages from './messages';

const addressFieldMap = {
  country: 'field_country_ref',
  state: 'field_state_ref',
  city: 'field_city',
  zip: 'field_postalcode',
  street1: 'field_addressline1',
  street2: 'field_addressline2',
  email: 'field_emailaddress',
  fax: 'field_faxnumber',
  phoneNumber: 'field_phonenumber',
  tollFreeNumber: 'field_tollfreenumber',
  url: 'field_url',
};

const contactFieldMap = {
  namePrefix: 'field_nameprefix',
  firstName: 'field_firstname',
  middleName: 'field_middlename',
  lastName: 'field_lastname',
  jobTitle: 'field_jobtitle',
  jobDescription: 'field_jobdescription',
  ...addressFieldMap,
};

const ApplicationMailingAddress = withCollegeService(
  Address,
  'overview.applicationMailingAddress',
  {},
  addressFieldMap,
  {
    'overview.applicationMailingAddress.country': 'overview.applicationMailingAddress.state',
  },
);

const AdmissionsOfficeContact = withCollegeService(
  Contact,
  'overview.admissionsOffice',
  {},
  contactFieldMap,
  {
    'overview.admissionsOffice.country': 'overview.admissionsOffice.state',
  },
);

const FinancialAidContact = withCollegeService(
  Contact,
  'overview.financialAid',
  {},
  contactFieldMap,
  {
    'overview.financialAid.country': 'overview.financialAid.state',
  },
);

const ContactInformation = ({ formatMessage }) => (
  <Form>
    <h4><FormattedMessage {...messages.applicationMailingAddress} /></h4>
    <ApplicationMailingAddress formatMessage={formatMessage} />
    <h4><FormattedMessage {...messages.admissionsOffice} /></h4>
    <AdmissionsOfficeContact formatMessage={formatMessage} />
    <h4><FormattedMessage {...messages.financialAid} /></h4>
    <FinancialAidContact formatMessage={formatMessage} />
  </Form>
);
ContactInformation.propTypes = {
  formatMessage: PropTypes.func,
};

export default ContactInformation;
